module.exports = __webpack_public_path__ + "56eeb315419b8db9ce75c00ae718d468.png";